import * as _ from 'lodash/fp';
import * as go from 'gojs';

import { getLink } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/getLink';

export const getLinksWithLengths = _.curry(
    (diagram: go.Diagram, links: go.ObjectData[]) =>
        _.map((link: go.ObjectData) => {
                const gojsLink = getLink(diagram, link);
                const pathElement = document.createElementNS(
                    'http://www.w3.org/2000/svg',
                    'path'
                );  
                pathElement.setAttribute('d', gojsLink.path.geometryString);

                return {
                ...link,
                length: pathElement.getTotalLength(),
            };
        })(links)
);
